import * as requests from "../coraWebComponents/utils/requests";
import { strToDate } from '../coraWebComponents/utils/convert';
import urls from "../constants/Urls";

const buildVyjadrenie = (id = "") => {
  return `${urls.VYJADRENIE}/${id}`;
};

const handleData = (res) => {
  res.Data.Items.forEach((item) => {
    if (item.D_VYJADRENIE) {
      item.D_VYJADRENIE = strToDate(item.D_VYJADRENIE);
    }
  });

  return res;
};

export const ulozitVyjadrenie = async (data) => {
  const url = buildVyjadrenie();

  try {
    let res = await requests.post(url + "ulozit", data);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getListVyjadrenie = async (filter, sort, page) => {
  const url = buildVyjadrenie();
  try {
    let res = await requests.getList(url, filter, sort, page);
    return handleData(res);
  } catch (error) {
    throw error;
  }
};
